import { faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function PaperPlaneIcon() {
  return <FontAwesomeIcon icon={faPaperPlane} className="h-auto" />;
}

export default PaperPlaneIcon;
